var DeliveryEstimates;

DeliveryEstimates = window.DeliveryEstimates != null ? window.DeliveryEstimates : window.DeliveryEstimates = {};

if (DeliveryEstimates.Views == null) {
  DeliveryEstimates.Views = {};
}

DeliveryEstimates.Model = Backbone.Model.extend({
  initialize: function(attrs) {
    return _.extend(this, attrs);
  },
  setZipcode: function(inputZipcode) {
    if (!/^\d{5}$/.test(inputZipcode)) {
      return;
    }
    this.set('zipcodeValue', inputZipcode);
    return this.fetch();
  },
  url: function() {
    var resource, zipcodeValue;
    zipcodeValue = this.get('zipcodeValue');
    resource = "/deals/delivery_estimates_proxy/" + this.dealId + ".json";
    if (zipcodeValue != null ? zipcodeValue.length : void 0) {
      return resource + "?zipcode=" + zipcodeValue + "&isGISDeal=true";
    } else if (this.isGISDeal) {
      return resource + "?isGISDeal=true";
    } else {
      return resource;
    }
  }
});

module.exports = DeliveryEstimates.Model;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvYWtlc2hhcmkvbmFwaXN0cmFuby9idWlsZC8xNDk1NjYwODk4MjQ5LTQzOTYvcHJvZHVjdGlvbi0yMDE3LjA1LjI0XzIxLjE5L2RlYWwvbW9kdWxlcy9kZWxpdmVyeV9lc3RpbWF0ZXMvZnJvbnRlbmQvbW9kZWxzL2RlbGl2ZXJ5X2VzdGltYXRlcy5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvdmFyL2dyb3Vwb24vaG9tZS9ha2VzaGFyaS9uYXBpc3RyYW5vL2J1aWxkLzE0OTU2NjA4OTgyNDktNDM5Ni9wcm9kdWN0aW9uLTIwMTcuMDUuMjRfMjEuMTkvZGVhbC9tb2R1bGVzL2RlbGl2ZXJ5X2VzdGltYXRlcy9mcm9udGVuZC9tb2RlbHMvZGVsaXZlcnlfZXN0aW1hdGVzLmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxJQUFBOztBQUFBLGlCQUFBLHNDQUFvQixNQUFNLENBQUMsb0JBQVAsTUFBTSxDQUFDLG9CQUFxQjs7O0VBQ2hELGlCQUFpQixDQUFDLFFBQVM7OztBQUUzQixpQkFBaUIsQ0FBQyxLQUFsQixHQUEwQixRQUFRLENBQUMsS0FBSyxDQUFDLE1BQWYsQ0FDeEI7RUFBQSxVQUFBLEVBQVksU0FBQyxLQUFEO1dBQ1YsQ0FBQyxDQUFDLE1BQUYsQ0FBUyxJQUFULEVBQWUsS0FBZjtFQURVLENBQVo7RUFHQSxVQUFBLEVBQVksU0FBQyxZQUFEO0lBQ1YsSUFBQSxDQUFjLFNBQVMsQ0FBQyxJQUFWLENBQWUsWUFBZixDQUFkO0FBQUEsYUFBQTs7SUFDQSxJQUFDLENBQUEsR0FBRCxDQUFLLGNBQUwsRUFBcUIsWUFBckI7V0FDQSxJQUFDLENBQUEsS0FBRCxDQUFBO0VBSFUsQ0FIWjtFQVFBLEdBQUEsRUFBSyxTQUFBO0FBQ0gsUUFBQTtJQUFBLFlBQUEsR0FBZSxJQUFDLENBQUEsR0FBRCxDQUFLLGNBQUw7SUFDZixRQUFBLEdBQVcsa0NBQUEsR0FBbUMsSUFBQyxDQUFBLE1BQXBDLEdBQTJDO0lBRXRELDJCQUFHLFlBQVksQ0FBRSxlQUFqQjthQUNLLFFBQUQsR0FBVSxXQUFWLEdBQXFCLFlBQXJCLEdBQWtDLGtCQUR0QztLQUFBLE1BRUssSUFBRyxJQUFDLENBQUEsU0FBSjthQUNBLFFBQUQsR0FBVSxrQkFEVDtLQUFBLE1BQUE7YUFHSCxTQUhHOztFQU5GLENBUkw7Q0FEd0I7O0FBb0IxQixNQUFNLENBQUMsT0FBUCxHQUFpQixpQkFBaUIsQ0FBQyJ9
